import { useSyncExternalStore } from 'react'

/**
 * «Доступна новая версия» (PWA, этап 4). Новая версия приложения обычно
 * подхватывается сама при следующем запуске с сетью: index.html берётся из
 * сети. Но установленное приложение на телефоне неделями живёт свёрнутым и не
 * перезапускается - тогда service worker обновляется в фоне, PWA сравнивает
 * сборки и, если открыта старая, объявляет обновление здесь. Экран показывает
 * кнопку «Обновить»; сам перезапуск только по нажатию, чтобы не потерять
 * незаконченную форму.
 */

let apply: (() => void) | null = null
const listeners = new Set<() => void>()

function subscribe(cb: () => void): () => void {
  listeners.add(cb)
  return () => {
    listeners.delete(cb)
  }
}

/** PWA: новая сборка готова, apply перезапускает приложение. */
export function announceAppUpdate(fn: () => void): void {
  apply = fn
  for (const l of [...listeners]) l()
}

/** Хук: функция обновления, если новая версия готова, иначе null. */
export function useAppUpdate(): (() => void) | null {
  return useSyncExternalStore(subscribe, () => apply, () => null)
}

/** Только для тестов. */
export function resetAppUpdateForTests(): void {
  apply = null
  for (const l of [...listeners]) l()
}

/**
 * Входной скрипт сборки из index.html (`/assets/index-<хеш>.js`): у разных
 * сборок разный хеш, по нему и сравниваем версии. null - не нашли.
 */
export function entryScriptOf(html: string): string | null {
  for (const tag of html.match(/<script\b[^>]*>/gi) ?? []) {
    if (!/\btype=["']module["']/i.test(tag)) continue
    const src = tag.match(/\bsrc=["']([^"']+)["']/i)
    if (src) return src[1]
  }
  return null
}
